import type { ReactNode, HTMLAttributes } from 'react';
import { Icon } from '../../basic/Icon';
import styles from './MobileNav.module.css';

export interface MobileNavProps extends HTMLAttributes<HTMLElement> {
  logo: ReactNode;
  onMenuOpen: () => void;
  className?: string;
}

export function MobileNav({
  logo,
  onMenuOpen,
  className,
  ...props
}: MobileNavProps) {
  return (
    <header
      className={`${styles.mobileNav} ${className || ''}`}
      {...props}
    >
      <button
        onClick={onMenuOpen}
        className={styles.hamburger}
        aria-label="Abrir menú"
        aria-expanded="false"
        type="button"
      >
        <Icon name="menu" size="lg" color="inherit" />
      </button>

      <div className={styles.logo}>
        {logo}
      </div>
    </header>
  );
}

MobileNav.displayName = 'MobileNav';
